<template>
  <v-main
    class="refresh-off"
  >
    <v-img
      :key="src"
      :src="require(`@/assets/${src}`)"
      gradient="to top, #00000020, #00000080"
      min-height="100vh"
      :height=" /* $vuetify.breakpoint.mdAndUp ? '100vh' : */ undefined"
    >
      <div
        :class="[$vuetify.breakpoint.mdAndUp && 'fill-height']"
        class="d-block d-md-flex"
      >
        <router-view />
      </div>
    </v-img>
    <material-snackbar
      v-for="(snackbar, index) in snackbars.filter(s => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :type="snackbar.type"
      :style="`bottom: ${(index * 100) + 8}px`"
      v-bind="{
        'bottom': true,
        'center': true
      }"
    >
      {{ $t(snackbar.text) }}
    </material-snackbar>
    <v-overlay
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-main>
</template>

<script>
  // Utilities
  import { get } from 'vuex-pathify'
  import MaterialSnackbar from '@/components/MaterialSnackbar'

  export default {
    name: 'FullPageView',

    components: {
      MaterialSnackbar,
    },
    data: () => ({
      srcs: {
        '/lock/': 'lock.jpg',
        '/login/': 'login.jpg',
        '/pricing/': 'pricing.jpg',
        '/register/': 'register.jpg',
        '/daily-flight/': 'clouds-2.jpg',
      },
    }),

    computed: {
      snackbars: get('alert/snackbars'),
      loading: get('app/loading'),
      path: get('route/path'),
      src () {
        console.log(this.path)
        return this.srcs[this.path] || 'clouds-2.jpg'
      },
    },
  }
</script>

<style lang="sass">
  .refresh-off
    overscroll-behavior: none
</style>
